 

import { createContext, useContext } from 'react'

export type LeafletMapContextType = {
  map: L.Map | null
}

export const LeafletMapContext = createContext<LeafletMapContextType>(null as never)

export const useLeafletMapContext = () => {
  const context = useContext(LeafletMapContext)

  if (context === undefined) {
    throw new Error(
      'useLeafletMapContext must be used within a LeafletMapContext.Provider',
    )
  }

  return context
}
